import * as actionTypes from '../actionTypes';
import axios from '../../../services/axios'
import {setMessage} from "../message";

export const loadLmsApplications = () => {
    return {
        type: actionTypes.LOAD_LMS_APPLICATIONS
    }
}

export const setLmsApplications = (lmsApplications) => {
    return {
        type: actionTypes.SET_LMS_APPLICATIONS,
        lmsApplications: lmsApplications
    }
}

export const getLmsApplications = () => {
    return (dispatch) => {
        dispatch(loadLmsApplications())
        axios.get(`/api/v1/lms/application-history`)
            .then(response => {
                dispatch(setLmsApplications(response.data))
            })
            .catch(error => {
                dispatch(setMessage({type: 'warning', text: "Не удалось подключиться к серверу."}))
            });
    }
}

////////////////////////////////////////////////////////////////

export const waitForSignLmsContract = () => {
    return {
        type: actionTypes.SIGN_LMS_CONTRACT
    }
}

export const receiveSignLmsContractResultOnSuccess = (result) => {
    return {
        type: actionTypes.RECEIVE_SIGN_LMS_CONTRACT_RESULT_ON_SUCCESS,
        lmsApplication: result
    }
}

export const receiveSignLmsContractResultOnError = () => {
    return {
        type: actionTypes.RECEIVE_SIGN_LMS_CONTRACT_RESULT_ON_ERROR,
    }
}

export const signLmsContract = (application, image) => {
    let dto = {
        lmsApplicationId: application.lmsApplicationId,
        imageSignature: image
    }
    return (dispatch) => {
        dispatch(waitForSignLmsContract())
        axios.post(`/api/v1/lms/sign-an-agreement`, dto)
            .then(response => {
                dispatch(setMessage({type: 'success', text: "Договор успешно подписан."}))
                dispatch( receiveSignLmsContractResultOnSuccess(response.data));
            } )
            .catch( error => {
                dispatch(setMessage({type: 'error', text: "Не удалось подписать договор."}))
                dispatch( receiveSignLmsContractResultOnError() );
            } );
    }
}

////////////////////////////////////////////////////////////////

export const loadLmsContract = () => {
    return {
        type: actionTypes.LOAD_LMS_CONTRACT
    }
}

export const onLoadLmsContractStopped = () => {
    return {
        type: actionTypes.SAVE_LMS_CONTRACT
    }
}

export const saveLmsContract = (response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;

    let filename = response.headers['file-name'];
    if (!filename || filename.length === 0) {
        filename = 'Договор.pdf';
    } else {
        filename = decodeURI(filename);
        filename += '.pdf';
    }

    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();

    return onLoadLmsContractStopped();
}

export const downloadLmsContract = (lmsApplicationId) => {
    return (dispatch) => {
        dispatch(loadLmsContract())
        axios.get(`/api/v1/lms/download-document-by-app-id?lms-application-id=${lmsApplicationId}`,
            {
                responseType: 'blob',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/pdf'
                }
            }
        ).then( response => {
            dispatch( saveLmsContract(response))
        } ).catch( error => {
            dispatch(setMessage({type: 'error', text: "Не удалось скачать договор."}))
            dispatch(onLoadLmsContractStopped())
        });
    }
}